export const seamhead = [
  {
    number: 'MC084',
    hasModel: false,
  },
  {
    number: 'MC085',
    hasModel: true,
  },
  {
    number: 'MC086',
    hasModel: true,
  },
  {
    number: 'MC087',
    hasModel: true,
  },
  {
    number: 'MC088',
    hasModel: true,
  },
  {
    number: 'MC089',
    hasModel: true,
  },
  {
    number: 'MC090',
    hasModel: true,
  },
  {
    number: 'MC091',
    hasModel: true,
  },
  {
    number: 'MC093',
    hasModel: true,
  },
  {
    number: 'MC094',
    hasModel: true,
  },
  {
    number: 'MC095',
    hasModel: false,
  },
  {
    number: 'MC096',
    hasModel: true,
  },
  {
    number: 'MC097',
    hasModel: true,
  },
  {
    number: 'MC098',
    hasModel: true,
  },
  {
    number: 'MC099',
    hasModel: true,
  },
  {
    number: 'MC100',
    hasModel: false,
  },
  {
    number: 'MC101',
    hasModel: false,
  },
  {
    number: 'MC102',
    hasModel: true,
  },
  {
    number: 'MC103',
    hasModel: false,
  },
  {
    number: 'MC104',
    hasModel: true,
  },
  {
    number: 'MC105',
    hasModel: true,
  },
  {
    number: 'MC106',
    hasModel: false,
  },
  {
    number: 'MC107',
    hasModel: false,
  },
  {
    number: 'MC108',
    hasModel: false,
  },
  {
    number: 'MC109',
    hasModel: false,
  },
  {
    number: 'MC110',
    hasModel: false,
  },
  {
    number: 'MC111',
    hasModel: true,
  },
  {
    number: 'MC112',
    hasModel: false,
  },
  {
    number: 'MC113',
    hasModel: false,
  },
  {
    number: 'MC114',
    hasModel: false,
  },
  {
    number: 'MC115',
    hasModel: false,
  },
  {
    number: 'MC116',
    hasModel: false,
  },
  {
    number: 'MC117',
    hasModel: true,
  },
  {
    number: 'MC118',
    hasModel: true,
  },
  {
    number: 'MC120',
    hasModel: false,
  },
  {
    number: 'MC121',
    hasModel: false,
  },
  {
    number: 'MC122',
    hasModel: false,
  },
  {
    number: 'MC123',
    hasModel: false,
  },
  {
    number: 'MC124',
    hasModel: true,
  },
  {
    number: 'MC125',
    hasModel: true,
  },
  {
    number: 'MCX',
    hasModel: false,
  },
];
